import { combineEpics } from 'redux-observable';
import campaignEpics from './modules/campaign/epics';
import campaignsEpics from './modules/campaigns/epics';

// @todo setup remaining redux modules with epics
export default combineEpics(campaignEpics, campaignsEpics);
